import axios from 'axios';
import { AUTH_URL, BASE_URL_SERVER } from '../helpers/constants';
const ORIGIN = window.location.hostname;
const baseURL = AUTH_URL[ORIGIN];
const axiosCopy = axios.create({ baseURL });

axios.defaults.baseURL = BASE_URL_SERVER;
// axios.defaults.headers.Domain = window.location.origin;

const setHeaders = token => {
  localStorage.setItem('token', token);
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  axiosCopy.defaults.headers.Authorization = `Bearer ${token}`;
};
const clearHeaders = () => {
  axios.defaults.headers.Authorization = ``;
  axiosCopy.defaults.headers.Authorization = ``;
  localStorage.removeItem('token');
};

export const login = async userdata => {
  const res = await axiosCopy.post('/login', userdata, {
    withCredentials: true,
  });
  setHeaders(res.data.token);
  return res.data;
};

export const logout = async () => {
  const res = await axiosCopy.post(
    '/logout',
    {},
    {
      withCredentials: true,
    },
  );
  clearHeaders();
  return res.data;
};

export const refresh = async () => {
  const res = await axiosCopy.post(
    '/refresh',
    {},
    {
      withCredentials: true,
    },
  );
  setHeaders(res.data.token);
  return res.data;
};

if (localStorage.getItem('token')) {
  setHeaders(localStorage.getItem('token'));
}
